/**
 * 系统相关路由
 */
import Layout from '@/views/layout/index.vue'
export default {
  path: '/admin',
  component: Layout,
  redirect: '/admin/virtualTable',
  name: 'admin',
  meta: { title: '系统管理', icon: 'example' },
  children: [
    {
      path: 'virtualTable',
      name: 'virtualTable',
      component: () => import('@/views/admin/virtualTable'),
      meta: {
        title: '虚拟表管理',
        icon: 'virtual-table',
        breadcrumb: ['系统管理',  '虚拟表']
      },
    },
  ],
}
